var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{
      'pig-tail-label-box':true,
      'pig-tail-label-left':(_vm.horzPosition==='left'),
      'pig-tail-label-right':(_vm.horzPosition==='right'),
      'pig-tail-label-top':(_vm.vertPosition==='top'),
      'pig-tail-label-bottom':(_vm.vertPosition==='bottom')}},[_c('div',{staticClass:"clear"}),_vm._v(" "),_c('div',{class:{
        'img-pig-tail':true,
        'img-pig-tail-bottom':true,
        'img-pig-tail-left':(_vm.horzPosition==='left'),
        'img-pig-tail-right':(_vm.horzPosition==='right')}}),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('div',{staticClass:"pig-tail-label-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})]),_vm._v(" "),_c('div',{staticClass:"clear"}),_vm._v(" "),_c('div',{class:{
        'img-pig-tail':true,
        'img-pig-tail-top':true,
        'img-pig-tail-left':(_vm.horzPosition==='left'),
        'img-pig-tail-right':(_vm.horzPosition==='right')}}),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = []

export { render, staticRenderFns }